import React from 'react';

import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { DemmiFS } from '@subhanhabib/demmilib';

import GalleryEditorImage from './GalleryEditorImage';

interface Props {
  CSSBlock: string;
  image: DemmiFS.DemmiImageResource;
  index: number;
  isVendor?: boolean;
  onClickDelete?: (index: number) => void;
}

const GalleryEditorImageSortable: React.FC<Props> = ({
  CSSBlock,
  image,
  index,
  isVendor,
  onClickDelete,
}) => {
  const sortable = useSortable({ id: image.thumbnail });
  const {
    attributes,
    listeners,
    // isDragging,
    setNodeRef,
    transform,
    transition,
  } = sortable;

  return (
    <GalleryEditorImage
      CSSBlock={CSSBlock}
      image={image}
      index={index}
      isVendor={isVendor}
      // key={image.thumbnail}
      ref={setNodeRef}
      style={{
        transition,
        transform: CSS.Transform.toString(transform),
      }}
      {...attributes}
      {...listeners}
      onClickDelete={onClickDelete}
    />
  );
};

export default GalleryEditorImageSortable;
